import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import AlertTypeForm from "./AlertTypeForm";

function AlertType() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "alert-types",
    id,
    { populate: ["icon"] }
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/alert-types");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataAlertType: any) => {
      const alertType = { ...dataAlertType };

      try {
        if (alertType.id) {
          await updateItem(alertType.id, alertType);
        } else {
          await saveItem(alertType);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <AlertTypeForm onSubmit={onSubmit} alertType={item} />
  );
}

export default AlertType;
